/** Order Status: every approved order item, ordered vs dispatched vs balance. */
import { ORDER_TYPES } from "@nexseed/shared";
import { createFileRoute, redirect, useNavigate } from "@tanstack/react-router";
import { z } from "zod";
import { ListPageSkeleton } from "@/components/app/skeletons";
import { useAuth } from "@/features/auth/store";
import { useFacilities } from "@/features/auth/use-facilities";
import { OrderStatusPage } from "@/features/sales-dispatch/components/order-status-page";

const search = z.object({
  status: z
    .enum(["open", "pending", "part_dispatched", "dispatched"])
    .optional(),
  type: z.enum(ORDER_TYPES).optional(),
  customerId: z.number().int().optional(),
  from: z.string().optional(),
  to: z.string().optional(),
  page: z.number().int().min(1).default(1),
});

export const Route = createFileRoute("/_app/orders/status")({
  validateSearch: search,
  beforeLoad: () => {
    if (!useAuth.getState().can("orders.view")) throw redirect({ to: "/" });
  },
  component: Page,
});

function Page() {
  const s = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  const { selected, ready } = useFacilities();
  if (!ready) return <ListPageSkeleton />;
  return (
    <OrderStatusPage
      facilityId={selected?.id}
      search={s}
      onSearch={(next) =>
        void navigate({ search: (prev) => ({ ...prev, ...next }) })
      }
    />
  );
}
